import { THoldingsOverview } from '@/components/Stocks/Widgets/types'
import { DOLLAR_SYMBOL } from '@/root/constants'

export const getHoldingsData = (holdingsOverview?: THoldingsOverview) => {
  return [
    {
      key: 'Current Value',
      value: holdingsOverview?.current_value
        ? `${DOLLAR_SYMBOL}${holdingsOverview.current_value}`
        : '-',
    },
    {
      key: 'Invested Value',
      value: holdingsOverview?.invested_amount
        ? `${DOLLAR_SYMBOL}${holdingsOverview.invested_amount}`
        : '-',
    },
    {
      key: 'Average Price',
      value: holdingsOverview?.avg_price
        ? `${DOLLAR_SYMBOL}${holdingsOverview.avg_price}`
        : '-',
    },
    {
      key: 'Gain/Loss',
      value: holdingsOverview?.total_profit_loss
        ? `${DOLLAR_SYMBOL}${holdingsOverview.total_profit_loss}`
        : '-',
    },
    {
      key: 'Overall Return',
      value: holdingsOverview?.total_percent_change
        ? `${holdingsOverview.total_percent_change}%`
        : '-',
      arrow: holdingsOverview?.total_percent_change
        ? holdingsOverview.total_percent_change > 0
          ? 'up'
          : 'down'
        : null,
      classname: holdingsOverview?.total_percent_change
        ? holdingsOverview.total_percent_change > 0
          ? 'text-brand-green-dark'
          : 'text-brand-red-dark'
        : null,
    },
    { key: 'Quantity', value: holdingsOverview?.quantity ?? '-' },
  ]
}
